import { render, staticRenderFns } from "./GpuMonitor.vue?vue&type=template&id=22241d50&scoped=true"
import script from "./GpuMonitor.vue?vue&type=script&lang=js"
export * from "./GpuMonitor.vue?vue&type=script&lang=js"
import style0 from "./GpuMonitor.vue?vue&type=style&index=0&id=22241d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22241d50",
  null
  
)

export default component.exports